// Linear interpolation function
// a: The start value | b: The end value | t: The interpolation value between the two floats
export default function lerp(a, b, t) {
  return (1 - t) * a + t * b
}
